"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactActions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _button = require("@kyruus/button");
var _utils = require("../../lib/utils");
var _styles = require("../styles");
const propTypes = {
  bookingOptionsButton: (0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    onClick: _propTypes.func.isRequired,
    ariaDescribedby: _propTypes.string,
    ariaLabel: _propTypes.string,
    ariaHasPopup: _propTypes.string,
    ariaControls: _propTypes.string,
    ariaExpanded: _propTypes.bool
  }),
  displayLinkToViewMoreAvailabilities: _propTypes.bool.isRequired,
  linkTarget: _propTypes.string,
  moreAvailabilitiesLinkText: _propTypes.node,
  onViewMoreClick: _propTypes.func,
  providerId: _propTypes.number.isRequired,
  viewMoreAriaLabel: _propTypes.string,
  viewMoreBookOnlineUrl: _propTypes.string,
  shouldRenderSlotsAsButtons: _propTypes.bool
};
const defaultProps = {
  onTimeSlotsClick: () => {},
  shouldRenderSlotsAsButtons: false
};
const CompactActions = _ref => {
  let {
    bookingOptionsButton,
    displayLinkToViewMoreAvailabilities,
    linkTarget,
    moreAvailabilitiesLinkText,
    onViewMoreClick,
    providerId,
    viewMoreAriaLabel,
    viewMoreBookOnlineUrl,
    shouldRenderSlotsAsButtons
  } = _ref;
  const showViewMore = displayLinkToViewMoreAvailabilities && viewMoreBookOnlineUrl;
  const showBookingOptions = bookingOptionsButton != null;
  let linkProps = {};
  if (!shouldRenderSlotsAsButtons) {
    linkProps = {
      href: viewMoreBookOnlineUrl,
      target: linkTarget,
      rel: (0, _utils.getLinkRel)(linkTarget)
    };
  }
  return /*#__PURE__*/_react.default.createElement(_styles.CompactFooter, null, showViewMore && /*#__PURE__*/_react.default.createElement(_button.ButtonLink, (0, _extends2.default)({
    "data-testid": "view-more-availabilities-link",
    "aria-label": viewMoreAriaLabel,
    as: shouldRenderSlotsAsButtons ? 'button' : 'a',
    onClick: e => onViewMoreClick(providerId, viewMoreBookOnlineUrl, e),
    mode: "flat"
  }, linkProps), moreAvailabilitiesLinkText), showBookingOptions && /*#__PURE__*/_react.default.createElement(_button.Button, {
    "data-testid": "booking-options-button",
    onClick: e => bookingOptionsButton.onClick(providerId, e),
    mode: "ghost",
    "aria-describedby": bookingOptionsButton.ariaDescribedby,
    "aria-label": bookingOptionsButton.ariaLabel,
    "aria-haspopup": bookingOptionsButton.ariaHasPopup,
    "aria-controls": bookingOptionsButton.ariaControls,
    "aria-expanded": bookingOptionsButton.ariaExpanded
  }, bookingOptionsButton.text));
};
exports.CompactActions = CompactActions;
CompactActions.propTypes = propTypes;
CompactActions.defaultProps = defaultProps;
CompactActions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CompactActions",
  "props": {
    "onTimeSlotsClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "shouldRenderSlotsAsButtons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "bookingOptionsButton": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "text": {
            "name": "string",
            "required": true
          },
          "onClick": {
            "name": "func",
            "required": true
          },
          "ariaDescribedby": {
            "name": "string",
            "required": false
          },
          "ariaLabel": {
            "name": "string",
            "required": false
          },
          "ariaHasPopup": {
            "name": "string",
            "required": false
          },
          "ariaControls": {
            "name": "string",
            "required": false
          },
          "ariaExpanded": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "displayLinkToViewMoreAvailabilities": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "linkTarget": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "moreAvailabilitiesLinkText": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onViewMoreClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "viewMoreAriaLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "viewMoreBookOnlineUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};